import React, { useState, useEffect } from 'react';
import client from '../api/client';
import { Spin, Button } from 'antd';
import { useParams } from 'react-router-dom';
import SiteNav from './SiteNav';
import SiteFooter from './SiteFooter';
import styles from './Blog.module.css';

const API_BASE = '/blog';

export default function BlogPost() {
  const { id } = useParams();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    client.get(`${API_BASE}/${id}`)
      .then(res => setBlog(res.data.blog || res.data))
      .catch(() => setError('مقاله یافت نشد.'))
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) return (
    <>
      <SiteNav />
      <div className={styles.blogList}><Spin size="large" /></div>
      <SiteFooter />
    </>
  );

  if (error) return (
    <>
      <SiteNav />
      <div className={styles.blogList}>
        <p style={{ color: '#999', textAlign: 'center' }}>{error}</p>
        <div style={{ textAlign: 'center' }}>
          <Button onClick={() => window.location.href = '/blog'}>بازگشت به مقالات</Button>
        </div>
      </div>
      <SiteFooter />
    </>
  );

  return (
    <>
      <SiteNav />
      <div className={styles.blogList} style={{ maxWidth: 800 }}>
        <Button
          onClick={() => window.location.href = '/blog'}
          style={{ marginBottom: 24 }}
        >
          ← بازگشت
        </Button>
        <h1 className={styles.articleTitle}>{blog?.title}</h1>
        <p className={styles.articleMeta}>
          نویسنده: <strong>{blog?.author?.firstName} {blog?.author?.lastName}</strong>
        </p>
        <p className={styles.articleMeta}>
          تاریخ انتشار: {blog?.publishedAt ? new Date(blog.publishedAt).toLocaleDateString('fa-IR') : '—'}
        </p>
        <div style={{ marginTop: 32, lineHeight: 2, whiteSpace: 'pre-wrap', color: '#333' }}>
          {blog?.content}
        </div>
      </div>
      <SiteFooter />
    </>
  );
}
